import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { AndromedaSearchInputComponent } from '../andromeda-search-input/andromeda-search-input.component';

@Component({
  selector: 'app-edit-litigation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    AndromedaSearchInputComponent,
  ],
  templateUrl: `./edit-litigation-dialog.component.html`,
  styleUrl: `./edit-litigation-dialog.component.scss`,
})
export class EditLitigationDialogComponent {
  selectedOption: any = null;
  searchForm: UntypedFormGroup;
  filteredOptions: any[];

  constructor(
    // eslint-disable-next-line no-unused-vars
    public dialogRef: MatDialogRef<EditLitigationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      type: 'topic' | 'entity' | 'proceduralAct';
      options: any;
      oldValue: any;
      litigationUri: string;
    }
  ) {
    this.searchForm = new UntypedFormGroup({
      search: new UntypedFormControl(''),
    });

    this.filteredOptions = this.filterOutOldValue(this.data.options);

    this.searchForm.get('search')?.valueChanges.subscribe((searchTerm) => {
      this.filterOptions(searchTerm);
    });
  }

  filterOutOldValue(options: any[]): any[] {
    return options.filter((option: any) => option.label !== this.data.oldValue);
  }

  filterOptions(searchTerm: string): void {
    if (!searchTerm) {
      this.filteredOptions = this.filterOutOldValue(this.data.options);
      return;
    }

    this.filteredOptions = this.data.options.filter(
      (option: any) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
        option.label !== this.data.oldValue
    );
  }

  selectOption(option: any): void {
    if (this.selectedOption === option.uri) {
      this.selectedOption = null;
    } else {
      this.selectedOption = option.uri;
    }
  }

  save(): void {
    if (this.selectedOption) {
      this.dialogRef.close(this.selectedOption);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
